import React from 'react'
import classnames from 'classnames'
import Form from '../query-form'

const clsPrefix = 'tnt-querylistscene-queryform'

export default class QueryForm extends React.PureComponent {
  constructor(props) {
    super(props)
    const { actions, form } = props

    this.form = form || Form.createForm()

    actions.on('setFormData', this.setFormData)
    actions.on('resetFormData', this.resetFormData)
  }

  render() {
    const { className, actions, extraActions, extralActions, qlsProps, ...props } = this.props

    return (
      <Form
        {...props}
        form={this.form}
        className={classnames(clsPrefix, { [className]: className })}
        // 前期拼写错误，导致需要兼容错误的api
        extraActions={extraActions || extralActions}
        onChange={this.onChange}
        onSearch={this.onSearch}
        onReset={this.onReset}
      />
    )
  }

  componentDidMount() {
    const { initialValues = {}, actions, qlsProps, memory } = this.props

    if (qlsProps.memory||memory) {
      actions.setFormData(
        {
          ...initialValues,
          ...actions.getFormData(),
        },
        false
      )
    } else {
      actions.setData('formData', initialValues)
    }
  }

  onSearch = () => {
    const { onSearch, actions } = this.props
    const values = actions.getFormData()
    const params = { ...values, current: 1 }

    // memory 与 url解析setForm时 监听事件异步
    actions.setData('formData', values)
    Promise.resolve().then(() => {
      onSearch && onSearch(params)
      actions.emit('search', params)
    })
  }

  onReset = () => {
    const { initialValues, onReset, actions } = this.props

    actions.setFormData(initialValues, false)

    onReset?.(initialValues)
    this.onSearch()
  }

  onChange = (newValues, changedInfo, ...rest) => {
    const { onChange, actions } = this.props

    actions.setFormData(newValues, false)
    onChange?.(newValues, changedInfo, ...rest)
  }

  setFormData = (data, needSearch) => {
    const { actions } = this.props
    actions.setData('formData', data)
    this.form.setValues(data)
    needSearch && this.onSearch()
  }

  resetFormData = (needSearch) => {
    const { initialValues, actions } = this.props

    actions.setFormData(initialValues, needSearch)
    this.form.resetValues()
  }

  componentWillUnmount() {
    const { actions } = this.props

    actions.removeListener('setFormData', this.setFormData)
    actions.removeListener('resetFormData', this.resetFormData)
  }
}

QueryForm.Field = Form.Field
